export default __webpack_public_path__ + "static/media/GoodMannerInPublic_08.937337d8.png";